import { Translation } from 'react-i18next';
import React, { useCallback, useEffect, useState } from 'react';
import cx from 'clsx';
import produce from 'immer';
import { IconRcDownArrow, IconRcUpArrow } from '@/assets/stream';

import styles from './index.module.scss';
import { CommentOrderBy } from '../../types';

const DEFAULT_ORDER_TAB = [
  {
    value: 'trust_degree',
    label: <Translation>{t => t('CommentOrder.12idgz')}</Translation>,
    reverse: true,
  },
  {
    value: 'create_at',
    label: <Translation>{t => t('CommentOrder.w4rys6')}</Translation>,
    reverse: true,
  },
];

export const CommentOrder = ({
  orderBy,
  onChange,
  className,
}: {
  orderBy: CommentOrderBy;
  onChange: (value: CommentOrderBy) => void;
  className?: string;
}) => {
  const [orderTabs, setOrderTabs] = useState(DEFAULT_ORDER_TAB);
  const [currentOrderBy, setCurrentOrderBy] = useState({
    value: orderBy.replace('-', ''),
    reverse: orderBy.startsWith('-'),
  });
  useEffect(() => {
    const { value, reverse } = currentOrderBy;
    onChange(`${reverse ? '-' : ''}${value}` as CommentOrderBy);
  }, [currentOrderBy, onChange]);

  useEffect(() => {
    setOrderTabs(pre =>
      produce(pre, draft => {
        const item = draft.find(i => i.value === currentOrderBy.value);
        if (item) {
          item.reverse = currentOrderBy.reverse;
        }
      }),
    );
  }, [currentOrderBy, orderTabs]);

  const handleOrderByChange = useCallback(
    ({ value, reverse }) => {
      if (currentOrderBy.value === value) {
        const newReverse = !reverse;
        setCurrentOrderBy({ value, reverse: newReverse });
      } else {
        setCurrentOrderBy({ value, reverse });
      }
    },
    [currentOrderBy],
  );

  return (
    <span className={cx(styles.container, className)}>
      {orderTabs.map(({ label, value, reverse }, index) => {
        const isActive = currentOrderBy.value === value;
        return (
          <span
            className={cx(
              styles.orderOperation,
              isActive && styles.isActive,
              index === 0 && styles.isFirst,
              index === 1 && styles.isLast,
            )}
            onClick={() => handleOrderByChange({ value, reverse })}
            key={value}>
            <span>{label}</span>
            <span className={styles.orderIconWrap}>
              {reverse ? <IconRcDownArrow /> : <IconRcUpArrow />}
            </span>
          </span>
        );
      })}
    </span>
  );
};
